<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('pickupCardCreation.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('pickupCardCreation.pageTitle'),
            href: '/pickup-card-creations'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <ts-loading-banner :loading="fetching">
          <ts-card>
            <ts-card-wrapper>
              <form class="form-horizontal">
                <div class="row mb-3">
                  <div class="col-sm-12 col-lg-7 col-md-6">
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label required"
                        >{{ $t('pickupCardCreation.studentName') }}</label
                      >
                      <div class="col-md-8">
                        <ts-select-student
                          v-model.number="model.student_id"
                          @change="fetchParent"
                        />
                        <div class="validate" v-if="errors.has('student_id')">
                          {{ errors.first('student_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label required"
                        >{{ $t('pickupCardCreation.relationship') }}</label
                      >
                      <div class="col-md-8">
                        <select
                          class="form-control"
                          v-model="model.relationship"
                          @change="setGuardian"
                          :class="{ 'is-invalid': errors.has('relationship') }"
                        >
                          <option
                            value
                            disabled
                            selected
                            style="display: none;"
                            >{{ $t('select') }}</option
                          >
                          <option
                            v-for="(relationship, index) in relationships"
                            :key="index"
                            :value="relationship.value"
                            >{{ relationship.description }}</option
                          >
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('relationship')"
                        >
                          {{ errors.first('relationship') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-form-label required">{{
                        $t('pickupCardCreation.guardianName')
                      }}</label>
                      <div class="col-md-8">
                        <div class="row">
                          <div class="col-md-6">
                            <input
                              type="text"
                              :placeholder="$t('pickupCardCreation.nameEn')"
                              v-model.trim="model.guardian"
                              :class="{ 'is-invalid': errors.has('guardian') }"
                              class="form-control"
                            />
                            <div
                              class="invalid-feedback"
                              v-if="errors.has('guardian')"
                            >
                              {{ errors.first('guardian') }}
                            </div>
                          </div>
                          <div class="col-md-6">
                            <input
                              type="text"
                              :placeholder="$t('pickupCardCreation.nameKh')"
                              v-model.trim="model.guardian_kh"
                              class="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-form-label">{{
                        $t('pickupCardCreation.contact')
                      }}</label>
                      <div class="col-md-8">
                        <div class="row">
                          <div class="col-md-6">
                            <input
                              type="text"
                              :placeholder="
                                $t('pickupCardCreation.phoneNumber')
                              "
                              v-model.trim="model.contact_no"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-6">
                            <input
                              type="text"
                              :placeholder="$t('pickupCardCreation.email')"
                              v-model.trim="model.email"
                              class="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-md-4 form-col-label control-label">{{
                        $t('pickupCardCreation.address')
                      }}</label>
                      <div class="col-md-8">
                        <textarea
                          class="form-control"
                          v-model="model.address"
                          rows="4"
                        ></textarea>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-form-label required">{{
                        $t('pickupCardCreation.issuedDate')
                      }}</label>
                      <div class="col-md-8">
                        <div class="row">
                          <div class="col-md-6">
                            <ts-date-picker-input v-model="model.issued_date" />
                            <div
                              class="validate"
                              v-if="errors.has('issued_date')"
                            >
                              {{ errors.first('issued_date') }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-form-label required">{{
                        $t('pickupCardCreation.expiryDate')
                      }}</label>
                      <div class="col-md-8">
                        <div class="row">
                          <div class="col-md-6">
                            <ts-date-picker-input v-model="model.expiry_date" />
                            <div
                              class="validate"
                              v-if="errors.has('expiry_date')"
                            >
                              {{ errors.first('expiry_date') }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-form-label required">{{
                        $t('pickupCardCreation.status')
                      }}</label>
                      <div class="col-md-8">
                        <div class="row">
                          <div class="col-md-6">
                            <select
                              class="form-control"
                              v-model="model.status"
                              :class="{ 'is-invalid': errors.has('status') }"
                            >
                              <option value>{{ $t('select') }}</option>
                              <option value="Active">{{
                                $t('pickupCardCreation.active')
                              }}</option>
                              <option value="Expired">{{
                                $t('pickupCardCreation.expired')
                              }}</option>
                            </select>
                            <div
                              class="invalid-feedback"
                              v-if="errors.has('status')"
                            >
                              {{ errors.first('status') }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-5 col-md-6">
                    <div class="row form-group">
                      <div class="col-md-12 text-center">
                        <ts-image-input
                          :title="$t('pickupCardCreation.uploadPhoto')"
                          :file="file"
                          @input="file => (model.photo = file)"
                          :width="175"
                          :height="225"
                          crop
                        ></ts-image-input>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-md-12 text-center">
                        <ts-button @click="takePicture">
                          <i class="fas fa-camera mr-2"></i>
                          {{ $t('pickupCardCreation.takePhoto') }}
                        </ts-button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </ts-card-wrapper>
            <hr />
            <ts-card-wrapper>
              <div class="row">
                <div class="col-sm-12 col-lg-12 col-md-12 text-right">
                  <ts-button
                    @click.prevent="
                      $router.push({ name: 'pickup-card-creation' })
                    "
                    >{{ $t('cancel') }}</ts-button
                  >
                  <ts-button
                    class="mr-2 ml-2"
                    color="primary"
                    outline
                    :waiting="saving_add_new"
                    @click.prevent="saveAddNew"
                    >{{ $t('save_add_new') }}</ts-button
                  >
                  <ts-button
                    color="primary"
                    :waiting="saving"
                    @click.prevent="save"
                    >{{ $t('save') }}</ts-button
                  >
                </div>
              </div>
            </ts-card-wrapper>
          </ts-card>
        </ts-loading-banner>
      </div>
    </div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import WebCam from './web-cam'
import TsSelectStudent from '@/components/SelectStudentLinkedParent'
import moment from 'moment'
import Compressor from 'compressorjs'
export default {
  name: 'pickup-card-creation-create',
  components: {
    TsSelectStudent
  },
  data () {
    return {
      model: {
        student_id: '',
        card_number: '',
        student_pickup_id: 0,
        guardian_kh: '',
        guardian: '',
        relationship: '',
        contact_no: '',
        email: '',
        address: '',
        issued_date: moment().format('DD-MM-YYYY'),
        expiry_date: moment()
          .add(1, 'Year')
          .format('DD-MM-YYYY'),
        status: 'Active',
        photo: ''
      },
      file: require('../../assets/user_default.png'),
      relationships: [
        {
          value: 'Father',
          description: 'Father'
        },
        {
          value: 'Mother',
          description: 'Mother'
        },
        {
          value: 'Other',
          description: 'Other'
        }
      ],
      errors: new Errors(),
      saving: false,
      fetching: false,
      saving_add_new: false
    }
  },
  created () {},
  computed: {
    ...mapState('pickupCardCreation', ['photoBlob', 'parents'])
  },
  methods: {
    fetchParent () {
      this.clear()
      this.fetching = true
      this.$store
        .dispatch('pickupCardCreation/fetchParent', this.model.student_id)
        .then(response => {
          this.model.card_number = response.data[0].card_number
          this.fetching = false
        })
        .catch(error => {
          this.fetching = false
          this.$toasted.error(error.message)
        })
    },
    takePicture () {
      this.$modal.show(
        WebCam,
        {},
        {
          height: 'auto',
          width: '40%',
          scrollable: true,
          clickToClose: false
        },
        {
          'before-close': this.getPhoto
        }
      )
    },
    setGuardian () {
      if (this.parents) {
        switch (this.model.relationship.toLowerCase()) {
          case 'father':
            this.model.guardian_kh = this.parents.father_name_kh
            this.model.guardian = this.parents.father_name_en
            this.model.contact_no = this.parents.father_phone1
            this.model.email = this.parents.father_emails
            this.model.photo = this.parents.father_photo
            this.model.address =
              this.parents.village !== null
                ? this.parents.house_no +
                  ', ' +
                  this.parents.street +
                  ', ' +
                  this.parents.village.village_name +
                  ', ' +
                  this.parents.commune.commune_name +
                  ', ' +
                  this.parents.district.district_name +
                  ', ' +
                  this.parents.province.province_name +
                  '.'
                : ''
            break
          case 'mother':
            this.model.guardian_kh = this.parents.mother_name_kh
            this.model.guardian = this.parents.mother_name_en
            this.model.contact_no = this.parents.mother_phone1
            this.model.email = this.parents.mother_emails
            this.model.photo = this.parents.mother_photo
            this.model.address =
              this.parents.village !== null
                ? this.parents.house_no +
                  ', ' +
                  this.parents.street +
                  ', ' +
                  this.parents.village.village_name +
                  ', ' +
                  this.parents.commune.commune_name +
                  ', ' +
                  this.parents.district.district_name +
                  ', ' +
                  this.parents.province.province_name +
                  '.'
                : ''
            break
          case 'other':
            this.model.guardian_kh = ''
            this.model.guardian = ''
            this.model.contact_no = ''
            this.model.email = ''
            this.model.photo = ''
            this.model.address = ''
            break
        }
        this.file = this.model.photo
          ? this.model.photo
          : require('../../assets/user_default.png')
      }
    },
    getPhoto () {
      this.file = this.readBlob(this.photoBlob)
      this.model.photo = new File([this.photoBlob], 'photo', {
        type: 'image/jpeg'
      })
      this.$store.commit('pickupCardCreation/SET_PHOTO_BLOB', '')
    },
    readBlob (blob) {
      return window.URL.createObjectURL(
        new Blob([blob], { type: 'image/jpeg' })
      )
    },

    async save () {
      this.errors = new Errors()
      this.saving = true
      if (
        this.model.photo instanceof File ||
        this.model.photo instanceof Blob
      ) {
        new Compressor(this.model.photo, {
          quality: 0.1,
          success: async result => {
            let formData = new FormData()
            formData.append('photo', result)
            let photo_path = await this.$store.dispatch(
              'pickupCardCreation/uploadPhoto',
              formData
            )

            await this.$store
              .dispatch(
                'pickupCardCreation/store',
                Object.assign({}, this.model, { photo: photo_path })
              )
              .then(response => {
                this.saving = false
                this.$toasted.success(response.message)
                this.$router.push({ name: 'pickup-card-creation' })
              })
              .catch(error => {
                this.saving = false
                this.errors = new Errors(error.errors)
                this.$toasted.error(error.message)
              })
          }
        })
      } else {
        this.$store
          .dispatch(
            'pickupCardCreation/store',
            Object.assign({}, this.model, { photo: this.model.photo })
          )
          .then(response => {
            this.saving = false
            this.$toasted.success(response.message)
            this.$router.push({ name: 'pickup-card-creation' })
          })
          .catch(error => {
            this.saving = false
            this.errors = new Errors(error.errors)
            this.$toasted.error(error.message)
          })
      }
    },
    async saveAddNew () {
      this.errors = new Errors()
      this.saving_add_new = true
      if (
        this.model.photo instanceof File ||
        this.model.photo instanceof Blob
      ) {
        new Compressor(this.model.photo, {
          quality: 0.1,
          success: async result => {
            let formData = new FormData()
            formData.append('photo', result)
            let photo_path = await this.$store.dispatch(
              'pickupCardCreation/uploadPhoto',
              formData
            )

            await this.$store
              .dispatch(
                'pickupCardCreation/store',
                Object.assign({}, this.model, { photo: photo_path })
              )
              .then(response => {
                this.clearForm()
                this.saving_add_new = false
                this.$toasted.success(response.message)
              })
              .catch(error => {
                this.saving_add_new = false
                this.errors = new Errors(error.errors)
                this.$toasted.error(error.message)
              })
          }
        })
      } else {
        this.$store
          .dispatch(
            'pickupCardCreation/store',
            Object.assign({}, this.model, { photo: this.model.photo })
          )
          .then(response => {
            this.clearForm()
            this.saving_add_new = false
            this.$toasted.success(response.message)
          })
          .catch(error => {
            this.saving_add_new = false
            this.errors = new Errors(error.errors)
            this.$toasted.error(error.message)
          })
      }
    },
    clearForm () {
      this.file = require('../../assets/user_default.png')
      this.model = {
        student_id: '',
        card_number: '',
        student_pickup_id: 0,
        guardian_kh: '',
        guardian: '',
        relationship: '',
        contact_no: '',
        email: '',
        address: '',
        issued_date: moment().format('DD-MM-YYYY'),
        expiry_date: moment()
          .add(1, 'Year')
          .format('DD-MM-YYYY'),
        status: 'Active',
        photo: ''
      }
    },
    clear () {
      ;(this.file = require('../../assets/user_default.png')),
        (this.model.guardian_kh = ''),
        (this.model.guardian = ''),
        (this.model.relationship = ''),
        (this.model.contact_no = ''),
        (this.model.email = ''),
        (this.model.address = ''),
        (this.model.photo = '')
    }
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'pickup-card-creation') {
      this.$store.commit('pickupCardCreation/RECEIVE_PARENTS', [])
    }
    next()
  }
}
</script>
<style scoped>
hr {
  border: 1px solid #ececec;
}
.file-input-container {
  width: 174px !important;
  margin: 0 auto;
  border: 1px solid #eaeaea;
  padding: 4px;
  border-radius: 5px;
}
</style>
